"use client";

import { useMemo, useState } from "react";
import styled from "styled-components";
import { getHotelBrandLogo } from "../../core/utils/getHotelBrandLogo";

export default function HotelCard({ data }: any) {
  const BrandLogo = useMemo(() => getHotelBrandLogo(data.b), [data]);

  return (
    <Card>
      <HotelImage src={data.i} alt="" />
      <HotelInfo>
        <HotelName>{data.n}</HotelName>
        <HotelDetail>
          <WrapperBrandLogo>{BrandLogo}</WrapperBrandLogo>
          <Points>{data.pt.toLocaleString()} pts</Points>
        </HotelDetail>
        {data.bookingUrl && (
          <BookNow target="_blank" href={data.bookingUrl}>
            Book Now
          </BookNow>
        )}
      </HotelInfo>
    </Card>
  );
}

const Card = styled.div`
  background: rgba(45, 45, 50, 0.7);
  border-radius: 12px;
  padding: 16px;
  color: #fff;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;

  @media (max-width: 475px) {
    padding: 10px;
    border-radius: 8px;
  }
`;

const HotelImage = styled.img`
  border-radius: 4px;
  width: 120px;
  min-height: 80px;
  height: 100%;
  max-height: 90px;
  object-fit: cover;
`;

const HotelName = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
`;

const HotelInfo = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

const WrapperBrandLogo = styled.div`
  width: 80px;
  height: 32px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 10px;
  padding-left: 8px;
  padding-right: 8px;
`;

const Points = styled.p`
  color: rgb(147 197 253);
  margin: 0;
  background-color: rgb(59 130 246 / 10%);
  padding: 6px;
  border-radius: 6px;
  font-weight: 500;

  @media (max-width: 475px) {
    font-size: 14px;
  }

  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

const HotelDetail = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
`;

export const BookNow = styled.a`
  margin: 0;
  margin-left: 3px;
  cursor: pointer;
  color: rgb(147 197 253);
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
`;
